import styled from "@emotion/styled";

import Tabs from "components/ui/tabs/Tabs";
import { IconProps } from "lib/icons/untitled_ui/UIcon";
import { SavedViewDataTypeUnion } from "lib/types/savedViews";
import PinnedViews from "./lists/PinnedViews";
import RecentViews from "./lists/RecentViews";
import Templates from "./lists/Templates";

export type BasicView = {
  id: string;
  name: string;
  description?: string | null;
  dataType: SavedViewDataTypeUnion;
};

type TabItem = {
  key: string;
  label: string;
  children: React.ReactNode;
  badge?: number;
  icon?: IconProps["icon"];
};

type SavedViewsMenuProps = {
  dataType: SavedViewDataTypeUnion;
  pinnedViews: BasicView[];
  recentViews?: BasicView[];
  templates?: BasicView[];
  setSelectedView: (viewId?: string, viewName?: string, context?: string) => void;
};

function SavedViewsMenu({
  dataType,
  pinnedViews,
  recentViews,
  templates,
  setSelectedView,
}: SavedViewsMenuProps) {
  let tabItems: TabItem[] = [
    {
      key: "pinned",
      label: "Pinned",
      icon: "pin02",
      children: (
        <PinnedViews
          dataType={dataType}
          pinnedViews={pinnedViews}
          setSelectedView={setSelectedView}
        />
      ),
    },
  ];

  if (recentViews) {
    tabItems.push({
      key: "recent",
      label: "Recent",
      icon: "clockRewind",
      children: (
        <RecentViews
          dataType={dataType}
          recentViews={recentViews}
          pinnedViews={pinnedViews}
          setSelectedView={setSelectedView}
        />
      ),
    });
  }

  if (templates) {
    tabItems.push({
      key: "templates",
      label: "Templates",
      icon: "layersThree01",
      children: (
        <Templates
          dataType={dataType}
          templates={templates}
          pinnedViews={pinnedViews}
          setSelectedView={setSelectedView}
        />
      ),
    });
  }

  return (
    <SavedViewsMenuWrapper>
      <Tabs
        items={tabItems}
        defaultValue={tabItems[0].key}
        variant={"savedViewsMenu"}
        padding="0 8px"
      />
    </SavedViewsMenuWrapper>
  );
}

const SavedViewsMenuWrapper = styled.div({
  display: "flex",
  width: "400px",
  height: "340px",
  maxHeight: "340px",
  flexDirection: "column",
  backgroundColor: "white",
});

export default SavedViewsMenu;
